/**
 * @fileoverview GET handler for the "/engagement/list_campaigns_for_report_builder" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementListCampaignsForReportBuilder } from "./constants";
import type { ListCampaignsForReportBuilderResult, ListCampaignsForReportBuilderParams } from "./types";

export const getListCampaignsForReportBuilder = reactQueryFetcherAdapter(
  engagementListCampaignsForReportBuilder,
  (
    signal: AbortSignal,
    args: ListCampaignsForReportBuilderParams
  ): Promise<ListCampaignsForReportBuilderResult> => {
    return fetch("/engagement/list_campaigns_for_report_builder", "GET", args, { signal });
  }
);
